import { useEffect, useState, useContext } from 'react';
import { getApplicationMetaData } from '../veevaIdApi';
import UnauthenticatedRouteLanguageContext from './UnauthenticatedRouteLanguageContext';
import useRequestState from './useRequestState';
import ResponseStatus from '../constants/ResponseStatus';
import { showErrorNotificationFromResponse } from './errorUtils';

const useAppMetadata = () => {
    const [appMetadata, setAppMetadata] = useState(null);
    const requestState = useRequestState();
    const { messageLanguage } = useContext(UnauthenticatedRouteLanguageContext);

    useEffect(() => {
        if (appMetadata) {
            return;
        }
        getApplicationMetaData(requestState).then((response) => {
            if (response.responseStatus === ResponseStatus.SUCCESS) {
                setAppMetadata(response.data);
            } else if (response.responseStatus === ResponseStatus.FAILURE) {
                const i18nOptions = { language: messageLanguage };
                showErrorNotificationFromResponse(response, i18nOptions);
            }
        });
        // omit messageLanguage from deps array to prevent unnecessary calls to getApplicationMetaData
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [requestState]);

    return appMetadata ?? {};
};

export default useAppMetadata;
